import { render, staticRenderFns } from "./StudentDocument.vue?vue&type=template&id=72c6637d&scoped=true"
import script from "./StudentDocument.vue?vue&type=script&lang=js"
export * from "./StudentDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c6637d",
  null
  
)

export default component.exports